import axios from 'axios';

export const changePassword = (data, options) => {
    return axios.post('/api/password', data, options);
}

export const getProvider = (data, options) => {
    return axios.post('/login/provider', data, options);
}

export const loginWithPassword = (data, options) => {
    return axios.post('/login/password', data, options);
}

export const forgotPassword = (data, options) => {
    return axios.post('/api/forgotPassword', data, options);
}
